/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { systemInfoFeatureKey } from './system-info.selectors';
import { systemInfoReducer } from './system-info.reducer';
import { SystemInfoEffects } from './system-info.effects';

/**
 * @description
 *     Global store to manage data returned from system-info API.
 * @author Zhiqian Liu
 */

@NgModule({
    imports: [
        StoreModule.forFeature(systemInfoFeatureKey, systemInfoReducer),
        EffectsModule.forFeature([SystemInfoEffects]),
    ],
})
export class SystemInfoModule {}
